import Vue from 'vue'
import PopupManager from './popup-manager'
import getScrollBarWidth from '@/utils/scrollbar-width'
import { getStyle, addClass, removeClass, hasClass } from '@/utils/dom'

// 用于生成id
let idSeed = 1

let scrollBarWidth

export default {
  props: {
    // 弹窗的显示状态
    visible: {
      type: Boolean,
      default: false,
    },
    zIndex: {},
    // 是否显示遮罩层
    modal: {
      type: Boolean,
      default: false,
    },
    // 遮罩层的自定义类
    modalClass: {},
    // 遮罩层是否挂载在body
    modalAppendToBody: {
      type: Boolean,
      default: false,
    },
    // 锁定滚动，移动端开启这个有bug
    lockScroll: {
      type: Boolean,
      default: false,
    },
    // 点击遮罩层关闭
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
  },

  beforeMount() {
    this._popupId = 'popup-' + idSeed++
    PopupManager.register(this._popupId, this)
  },

  beforeDestroy() {
    PopupManager.deregister(this._popupId)
    PopupManager.closeModal(this._popupId)

    this.restoreBodyStyle()
  },

  data() {
    return {
      // 是否已经打开
      opened: false,
      // body原来的padding
      bodyPaddingRight: null,
      // 禁止滚动后body的padding
      computedBodyPaddingRight: 0,
      // body没有隐藏滚动条的类
      withoutHiddenClass: true,
      // 控制弹窗主体的显示
      rendered: false,
    }
  },

  watch: {
    visible(val) {
      if (val) {
        if (this._opening) return
        if (!this.rendered) {
          this.rendered = true
          Vue.nextTick(() => {
            this.open()
          })
        } else {
          this.open()
        }
      } else {
        this.close()
      }
    },
  },

  methods: {
    open(options) {
      if (!this.rendered) {
        this.rendered = true
      }

      const props = Object.assign({}, this.$props || this, options)

      this.doOpen(props)
    },

    doOpen(props) {
      if (this.opened) return

      this._opening = true

      const dom = this.$el

      const modal = props.modal

      const zIndex = props.zIndex
      if (zIndex) {
        PopupManager.zIndex = zIndex
      }

      if (modal) {
        if (this._closing) {
          PopupManager.closeModal(this._popupId)
          this._closing = false
        }
        PopupManager.openModal(
          this._popupId,
          PopupManager.nextZIndex(),
          this.modalAppendToBody ? undefined : dom,
          props.modalClass,
          props.modalFade
        )
        // body禁止滚动的逻辑
        if (props.lockScroll) {
          this.withoutHiddenClass = !hasClass(document.body, 'app-popup-parent--hidden')
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight
            this.computedBodyPaddingRight = parseInt(getStyle(document.body, 'paddingRight'), 10)
          }
          scrollBarWidth = getScrollBarWidth()
          const bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight
          const bodyOverflowY = getStyle(document.body, 'overflowY')
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px'
          }
          addClass(document.body, 'app-popup-parent--hidden')
        }
      }

      // 设置弹窗dom的样式
      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute'
      }

      dom.style.zIndex = PopupManager.nextZIndex()
      this.opened = true

      this.onOpen && this.onOpen()

      this.doAfterOpen()
    },

    doAfterOpen() {
      this._opening = false
    },

    close() {
      if (this.willClose && !this.willClose()) return
      this.doClose()
    },

    // 真正的关闭逻辑
    doClose() {
      this._closing = true

      this.onClose && this.onClose()

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200)
      }

      this.opened = false

      this.doAfterClose()
    },

    doAfterClose() {
      PopupManager.closeModal(this._popupId)
      this._closing = false
    },

    // 移除body禁止滚动的样式
    restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight
        removeClass(document.body, 'app-popup-parent--hidden')
      }
      this.withoutHiddenClass = true
    },
  },
}

export { PopupManager }
